import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import {
  MatchCompareResponse,
  deserializeMatchCompare,
} from "./match-compare.ws";

/**
 * Sample WS to get the sample match comparison. Sends token if available.
 */
@Injectable({
  providedIn: "root",
})
export class MatchCompareSampleWS {
  constructor(private handler: BaseHandler) {}
  execute(token: string | null): Observable<MatchCompareResponse> {
    const builder = new HandlerBuilder()
      .setUrl(ApiUrls.SAMPLE_STATISTICS_COMPARE_ENDPOINT())
      .setMethod(HttpMethod.get);
    if (token != null) {
      builder.setAuthorization(new TokenAuthorization(token));
    }
    return this.handler
      .execute(builder.build())
      .pipe(map(deserializeMatchCompare));
  }
}
